import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b4e4ee9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu-wrapper" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]

import { onMounted, ref, watch, computed } from 'vue'
import { useRoute } from 'vue-router'
import home from '@/assets/img/menu/icon-home.svg'
import homeA from '@/assets/img/menu/icon-home-active.svg'
import tenant from '@/assets/img/menu/icon-tenant.svg'
import tenantA from '@/assets/img/menu/icon-tenant-active.svg'
import product from '@/assets/img/menu/icon-product.svg'
import productA from '@/assets/img/menu/icon-product-active.svg'
import device from '@/assets/img/menu/icon-device.svg'
import deviceA from '@/assets/img/menu/icon-device-active.svg'
import packageI from '@/assets/img/menu/icon-package.svg'
import packageA from '@/assets/img/menu/icon-package-active.svg'
import config from '@/assets/img/menu/icon-config.svg'
import configA from '@/assets/img/menu/icon-config-active.svg'
import data from '@/assets/img/menu/icon-data.svg'
import dataA from '@/assets/img/menu/icon-data-active.svg'
import warning from '@/assets/img/menu/icon-warning.svg'
import warningA from '@/assets/img/menu/icon-warning-active.svg'
import dataApplication from '@/assets/img/menu/icon-data-application.svg'
import dataApplicationA from '@/assets/img/menu/icon-data-application-active.svg'

import { PLATFORM_TYPE } from '@/common'
import { useGlobalStore } from '@/stores/global'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const globalStore = useGlobalStore()

const menuData: any = ref([
  {
    label: '首页',
    icon: home,
    active: homeA,
    router: '/',
  },
  {
    label: '租户管理',
    icon: tenant,
    active: tenantA,
    router: '/tenant',
    children: [
      {
        label: '租户列表',
        router: '/tenant/tenant-list',
      },
    ],
  },
  {
    label: '产品管理',
    icon: product,
    active: productA,
    router: '/product',
    children: [
      {
        label: '产品列表',
        router: '/product/product-list',
      },
      {
        label: '产品模板',
        router: '/product/template',
      },
    ],
  },
  {
    label: '设备管理',
    icon: device,
    active: deviceA,
    router: '/device',
    children: [
      {
        label: '设备列表',
        router: '/device/device-list',
      },
      {
        //label: '设备分布',
        label: '地面站分布',
        router: '/device/device-location',
      },
      {
        label: '轨迹回放',
        router: '/device/device-trail',
      },
      {
        label: '地面站管理',
        router: '/device/device-station',
      },
    ],
  },
  {
    label: '营销管理',
    icon: packageI,
    active: packageA,
    router: '/sales',
    children: [
      {
        label: '套餐管理',
        router: '/sales/package-list',
      },
      {
        label: '订单管理',
        router: '/sales/order-list',
      },
    ],
  },
  {
    label: '告警中心',
    icon: warning,
    active: warningA,
    router: '/alarm',
    children: [
      {
        label: '告警记录',
        router: '/alarm/alarm-list',
      },
    ],
  },
  {
    label: '数据中心',
    icon: data,
    active: dataA,
    router: '/statistics',
    children: [
      // {
      //   label: '历史数据',
      //   router: '/statistics/statistics-history',
      // },
      {
        label: '报表配置',
        router: '/statistics/report-config',
      },
      {
        label: '报表查询',
        router: '/statistics/report',
      },
      {
        label: '文件查询',
        router: '/statistics/files',
      },
      {
        label: '视频监控',
        router: '/statistics/videos',
      },
    ],
  },
  {
    label: '系统管理',
    icon: config,
    active: configA,
    router: '/config',
    children: [
      {
        label: '用户管理',
        router: '/config/user-list',
      },
      {
        label: '应用管理',
        router: '/config/app',
      },
      {
        label: '诊断日志',
        router: '/config/log-list',
      },
      {
        label: '设备日志',
        router: '/config/log-file',
      },
      {
        label: '数据字典',
        router: '/config/dictionary',
      },
      {
        label: '升级管理',
        router: '/config/firmware',
      },
    ],
  },
  {
    label: '数据应用',
    icon: dataApplication,
    active: dataApplicationA,
    router: '/data-application',
    dataCenter: true,
    children: [
      {
        label: '数据导出',
        router: '/data-application/export',
      },
    ],
  },
])

const currentMenu = computed(() => {
  return menuData.value.filter(({ dataCenter }: any) => {
    return globalStore.platformType === PLATFORM_TYPE.OPERATION
      ? dataCenter !== true
      : dataCenter
  })
})

const defaultActive = ref('')

const $route = useRoute()

watch($route, () => {
  matchPath()
})

onMounted(() => {
  matchPath()
})

// 运营中心的路由
const dataCenterList = menuData.value
  .filter((_: any) => _.dataCenter)
  .map((_: any) => (_.children ? _.children : _))
  .flat(Infinity)
  .filter(Boolean)
  .map((_: any) => _.router)

const matchPath = () => {
  defaultActive.value = $route.path

  // 自动切换平台
  const currentType = dataCenterList.includes($route.path)
    ? PLATFORM_TYPE.DATA_CENTER
    : PLATFORM_TYPE.OPERATION
  globalStore.setPlatformType(currentType)
}

const select = (router: string) => {
  defaultActive.value = router
}

return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_menu, {
      "active-text-color": "#186DF5",
      "default-active": defaultActive.value,
      "text-color": "#4E5969",
      router: "",
      onSelect: select
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentMenu.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            (!item.children)
              ? (_openBlock(), _createBlock(_component_el_menu_item, {
                  key: 0,
                  index: item.router
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: defaultActive.value === item.router ? item.active : item.icon,
                      alt: ""
                    }, null, 8, _hoisted_2),
                    _createElementVNode("span", null, _toDisplayString(item.label), 1)
                  ]),
                  _: 2
                }, 1032, ["index"]))
              : (_openBlock(), _createBlock(_component_el_sub_menu, {
                  key: 1,
                  index: item.router
                }, {
                  title: _withCtx(() => [
                    _createElementVNode("img", {
                      src: item.icon,
                      alt: ""
                    }, null, 8, _hoisted_3),
                    _createElementVNode("span", null, _toDisplayString(item.label), 1)
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (vv, ii) => {
                      return (_openBlock(), _createBlock(_component_el_menu_item, {
                        index: vv.router,
                        key: ii
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(vv.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["index"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["index"]))
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["default-active"])
  ]))
}
}

})